import { render, staticRenderFns } from "./SkeletonBanner.vue?vue&type=template&id=cb1f55e0"
import script from "./SkeletonBanner.vue?vue&type=script&lang=js"
export * from "./SkeletonBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports